import { PresetPicker } from "./preset-picker.tsx";

const DURATION_OPTIONS = ["15 min", "30 min", "45 min", "1 hour", "1.5 hours", "2 hours"];

/** Default selected index — "30 min" is index 1 in DURATION_OPTIONS. */
const DEFAULT_INDEX = 1;

interface DurationPickerProps {
  onSelect: (duration: string) => void;
  /** Previously selected value — pre-selects the matching option or pre-fills the custom input. */
  defaultValue?: string | null;
}

/** Single-select duration picker with preset options and custom input. */
export function DurationPicker({ onSelect, defaultValue }: DurationPickerProps) {
  return (
    <PresetPicker
      options={DURATION_OPTIONS}
      onSelect={onSelect}
      defaultValue={defaultValue}
      defaultIndex={DEFAULT_INDEX}
      placeholder="Type to filter or enter duration..."
      ariaLabel="Duration options"
      layout="list"
    />
  );
}
